module.exports = __webpack_public_path__ + "img/partners-icon11.e5f91d42.jpg";